import { BigNumberish, BrowserProvider, Contract, Eip1193Provider, JsonRpcSigner } from 'ethers';
import { create } from 'zustand';
import { usdt_address } from '../web3/config';
import { produce } from 'immer';

export interface IUserPub {
    userId: number;
    email: string;
    phone: string;
    isAdmin: number;
    walletAddress: string;
    smnetStatus: string;
    smnetData: any;
}


export interface ISunConnectedWallet {
    walletProvider: Eip1193Provider,
    address: `0x${string}`,
    chainId: number,
    ethersProvider: BrowserProvider,
    signer: JsonRpcSigner,

    TokenContract: Contract,
    Token2PlusContract: Contract,
    USDTContract: Contract,
    PayoutContractSDBN3: Contract,
    PayoutContractSDBN3Plus: Contract,
}

export interface ISunWalletAmounts {
    TokenBalance: BigNumberish;
    Token2PlusBalance: BigNumberish;
    USDTBalance: BigNumberish;
    BNBBalance: BigNumberish;
}


export interface ISunPayout {
    id: string;
    status: string;
    userAmount: BigNumberish;
    date: number;
}

export interface ISunPayoutInfo {
    payouts: ISunPayout[];
    userSum: BigNumberish;
    userWithdrawn: BigNumberish;
    withdrawAble: BigNumberish;
}



export interface SunState {
    isLoading: boolean,
    walletError: string,
    setIsLoading: (v: boolean) => void;
    setWalletError: (v: string) => void;


    // --------------------------------
    connectedWallet: ISunConnectedWallet | null,
    walletDisconnected: () => void,
    walletConnected: (sunWalletProps: ISunConnectedWallet) => void,

    initialRequest: boolean;
    setInitialRequest: (v: boolean) => void;

    walletAmounts: ISunWalletAmounts;
    setWalletAmounts: (v: Partial<ISunWalletAmounts>) => void;

    payoutInfoSDBN3: ISunPayoutInfo;
    payoutInfoSDBN3Plus: ISunPayoutInfo;


    // --------------
    loadBalance: () => void;
    //loadOwnerInfo: () => void;
    loadPayoutsSDBN3: () => void;
    loadPayoutsSDBN3Plus: () => void;
    /*loadPayoutsRemote: WSysUseResult<any>;
    setLoadPayoutsRemote: (v : Partial<WSysUseResult<any>>) => void;*/

    user: IUserPub | null;
    setUser: (v: IUserPub | null) => void;

}

export const useSunStore = create<SunState>()(
    (set, get) => ({
        isLoading: false,
        walletError: '',
        setIsLoading: (v) => set(state => ({ isLoading: v })),
        setWalletError: (v) => set(state => ({ walletError: v })),
        initialRequest: false,
        setInitialRequest: (v) => set(state => ({ initialRequest: v })),

        // ----------------------------------
        user: null,
        setUser: (v: IUserPub | null) => set(produce(state => { state.user = v })),

        // ----------------------------------

        connectedWallet: null,
        walletDisconnected: () => set(state => ({
            connectedWallet: null,
            initialRequest: false,
        })),
        walletConnected: (sunWalletProps) => set(state => ({
            connectedWallet: sunWalletProps,
            initialRequest: false,
        })),

        // ------

        walletAmounts: {
            TokenBalance: BigInt(0),
            Token2PlusBalance: BigInt(0),
            USDTBalance: BigInt(0),
            BNBBalance: BigInt(0),
        },
        setWalletAmounts: (v) => set(state => ({
            walletAmounts: Object.assign({}, get().walletAmounts, v)
        })),


        payoutInfoSDBN3: {
            payouts: new Array<ISunPayout>(),
            userSum: BigInt(0),
            userWithdrawn: BigInt(0),
            withdrawAble: BigInt(0),
        },

        payoutInfoSDBN3Plus: {
            payouts: new Array<ISunPayout>(),
            userSum: BigInt(0),
            userWithdrawn: BigInt(0),
            withdrawAble: BigInt(0),
        },



        // ==========================================================
        // -------------------- ACTIONS -----------------------------
        // ==========================================================
        // --------------------
        loadBalance: async () => {
            try {
                get().setIsLoading(true);
                get().setWalletError('');
                const wallet = get().connectedWallet;
                if (!wallet)
                    throw Error('User disconnected');
                console.log('---------------------------------------');
                console.log(wallet.address, usdt_address);


                const TokenBalance = await wallet.TokenContract.balanceOf(wallet.address);
                const Token2PlusBalance = await wallet.Token2PlusContract.balanceOf(wallet.address);
                const USDTBalance = await wallet.USDTContract.balanceOf(wallet.address);
                const BNBBalance = await wallet.ethersProvider.getBalance(wallet.address);

                set((state) => ({
                    walletAmounts: {
                        TokenBalance,
                        Token2PlusBalance,
                        USDTBalance,
                        BNBBalance,
                    }
                }))
            } catch (ex) {
                get().setWalletError('' + ex);
            } finally {
                get().setIsLoading(false);
            }
        },

        // --------------------
        loadPayoutsSDBN3: async () => {
            console.log('----load payout SDBN3 ----')
            const wallet = get().connectedWallet;
            if (!wallet)
                throw Error('User disconnected');
            let payouts = new Array<ISunPayout>();
            let wDates = await wallet.PayoutContractSDBN3.getDates();
            let wAmounts = await wallet.PayoutContractSDBN3.getUserData(wallet.address);
            //let userSum = await wallet.PayoutContractSDBN3.userSum(wallet.address);
            let userSum = BigInt(0);
            let userWithdrawn = await wallet.PayoutContractSDBN3.userWithdrawn(wallet.address);
            

            for (let id in wDates) {
                let date = wDates[id];
                let amount = wAmounts[id];
                userSum += amount;
                payouts.push({
                    id, userAmount: amount, date, status: ''
                });
            }
            let withdrawAble = userSum - userWithdrawn;
            console.log('payouts:', payouts);
            set((state) => ({
                payoutInfoSDBN3: {
                    payouts, userSum, userWithdrawn, withdrawAble
                }
            }))
        },


        // --------------------
        loadPayoutsSDBN3Plus: async () => {
            console.log('----load payout SDBN3Plus ----')
            const wallet = get().connectedWallet;
            if (!wallet)
                throw Error('User disconnected');
            let payouts = new Array<ISunPayout>();

            let wDates = await wallet.PayoutContractSDBN3Plus.getDates();
            console.log('dates', wDates);

            let wAmounts = await wallet.PayoutContractSDBN3Plus.getUserData(wallet.address);
            console.log('amounts', wAmounts);

            let userSum = await wallet.PayoutContractSDBN3Plus.userSum(wallet.address);
            console.log('userSum', userSum);

            let userWithdrawn = await wallet.PayoutContractSDBN3Plus.userWithdrawn(wallet.address);
            console.log('userWithdrawn', userWithdrawn);

            let withdrawAble = userSum - userWithdrawn;
            console.log('withdrawAble', withdrawAble);

            for (let id in wDates) {
                let date = wDates[id];
                let amount = wAmounts[id];
                payouts.push({
                    id, userAmount: amount, date, status: ''
                });
            }
            console.log('payouts:', payouts);
            set((state) => ({
                payoutInfoSDBN3Plus: {
                    payouts, userSum, userWithdrawn, withdrawAble
                }
            }))
        },


    }),
)